import React, { Component } from 'react';
import { string, bool, number, func } from 'prop-types';
import { translate } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux';
import shave from 'shave';

import Link from '@blueberry/components/Link';

import { generatePostURL } from '@blueberry/redux/navigation';

import { abbrivationFormat } from '@blueberry/utils/datetime';

import MediaImage from '@blueberry/components/MediaImage';

import styles from './MediaCard.scss';
const cx = require('classnames/bind').bind(styles);

const mapStateToProps = state => ({
  getPostURL: generatePostURL(state),
});

class MediaCard extends Component {
  static propTypes = {
    authorName: string.isRequired,
    durationTime: number.isRequired,
    getPostURL: func.isRequired,
    id: string.isRequired,
    mediaAltText: string.isRequired,
    mediaUrl: string.isRequired,
    publishDate: string.isRequired,
    title: string.isRequired,
    type: string.isRequired,
    urlTitle: string.isRequired,
    className: string,
    mediaImageUrl: string,
    smallMedia: bool,
  };

  static defaultProps = {
    mediaImageUrl: '',
    smallMedia: false,
  };

  componentDidMount() {
    // shave only accpect number with max-height, 48 = 48px
    shave(`.${styles.title}`, 48, {
      spaces: false, // supports non-spaced languages (Non-ascii)
    });
  }

  render() {
    const {
      title,
      urlTitle,
      publishDate,
      mediaUrl,
      mediaAltText,
      durationTime,
      type,
      id,
      className,
      smallMedia,
      authorName,
      getPostURL,
    } = this.props;

    const postURL = getPostURL({ title: urlTitle, id });

    return (
      <div className={cx(styles.root, className, { smallMedia })}>
        <div className={styles.imageWrapper}>
          <MediaImage
            mediaAltText={mediaAltText}
            mediaUrl={mediaUrl}
            durationTime={durationTime}
            type={type}
            href={postURL}
          />
        </div>
        <div className={styles.description}>
          <Link title={title} to={postURL}>
            <h6 className={styles.title}>{title}</h6>
          </Link>
          <div className={styles.time}>
            <span>{authorName}</span>
            <span className={styles.dot} />
            <span>{abbrivationFormat(publishDate)}</span>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  translate('content'),
  connect(mapStateToProps)
)(MediaCard);



// WEBPACK FOOTER //
// ./app/components/ChannelBar/components/MediaCard/MediaCard.jsx